import {
  FaStethoscope,
  FaUserMd,
  FaXRay,
  FaFlask,
  FaCut,
  FaHeartbeat,
  FaSyringe,
  FaChartLine,
  FaHome,
} from "react-icons/fa";

export const servicesData = [
  {
    id: "general-consultation",
    title: "General Consultation",
    shortDesc: "Expert medical advice for all ages.",
    fullDesc:
      "Our general consultation service provides comprehensive medical assessments for patients of all ages. We focus on preventive care, early detection, and personalized treatment plans. Whether you need a routine check-up, diagnosis of a minor ailment, or advice on managing chronic conditions, our experienced team is here to help.",
    icon: FaStethoscope,
    bgImage: "/assets/services/consultation.jpg",

    features: [
      "Comprehensive physical examinations",
      "Chronic disease management",
      "Preventive health screenings",
      "Health risk assessments",
      "Personalized treatment plans",
    ],
    benefits: [
      "Early detection of health issues",
      "Improved overall well-being",
      "Personalized care tailored to your needs",
      "Convenient scheduling",
    ],
    price: "KSh 2,500 – KSh 5,000",
    duration: "30-60 minutes",
  },
  {
    id: "specialist-appointments",
    title: "Specialist Appointments",
    shortDesc: "Access to top specialists.",
    fullDesc:
      "We connect you with a network of highly qualified specialists across various fields including cardiology, dermatology, orthopedics, neurology, and more. Our team coordinates referrals and appointments to ensure you receive expert care without the wait.",
    icon: FaUserMd,
    bgImage: "/assets/services/specialist.png",
    features: [
      "Referrals to leading specialists",
      "Coordinated appointment scheduling",
      "Multidisciplinary care coordination",
      "Second opinion services",
    ],
    benefits: [
      "Access to top experts",
      "Reduced waiting times",
      "Streamlined care coordination",
    ],
    price: "Varies by specialist",
    duration: "45-90 minutes",
  },
  {
    id: "diagnostic-imaging",
    title: "Diagnostic Imaging",
    shortDesc: "X-ray, ultrasound, and more.",
    fullDesc:
      "Our modern imaging department offers a full range of diagnostic services including X‑ray, ultrasound, CT scans, and MRI. Using state‑of‑the‑art equipment, we provide accurate, fast results to support your diagnosis and treatment.",
    icon: FaXRay,

    bgImage: "/assets/services/ultrasound.png",
    features: [
      "Digital X‑ray",
      "Ultrasound (including obstetric)",
      "CT scans",
      "MRI",
      "Echocardiography",
    ],
    benefits: [
      "Quick turnaround times",
      "Radiologist interpretation",
      "Comfortable environment",
    ],
    price: "KSh 3,000 – KSh 15,000",
    duration: "15-60 minutes",
  },
  {
    id: "laboratory-tests",
    title: "Laboratory Tests",
    shortDesc: "Accurate blood tests, urinalysis, and more.",
    fullDesc:
      "Our on‑site laboratory is equipped for a wide range of tests including hematology, biochemistry, microbiology, and pathology. We ensure accurate results with strict quality control, and our team works with you to interpret findings and guide next steps.",
    icon: FaFlask,
    bgImage: "/assets/services/lab.png",
    features: [
      "Complete blood count (CBC)",
      "Lipid profile",
      "Blood glucose",
      "Thyroid function tests",
      "Urinalysis",
      "STI screening",
    ],
    benefits: [
      "Fast, reliable results",
      "Confidentiality",
      "Experienced lab technicians",
    ],
    price: "KSh 500 – KSh 10,000",
    duration: "Results within 24-48 hours",
  },
  {
    id: "minor-surgical-procedures",
    title: "Minor Surgical Procedures",
    shortDesc: "In-office surgeries like suturing, excision, etc.",
    fullDesc:
      "We perform minor surgical procedures in a sterile, comfortable environment. These include suturing of wounds, excision of skin lesions, incision and drainage of abscesses, and other minor surgeries. Our experienced medical staff ensures your safety and comfort throughout.",
    icon: FaCut,
    bgImage: "/assets/services/minor-surgery.jpg",
    features: [
      "Wound suturing",
      "Lesion removal (cysts, moles, etc.)",
      "Abscess drainage",
      "Ingrown toenail removal",
      "Joint injections",
    ],
    benefits: ["Minimal waiting time", "Sterile environment", "Follow‑up care"],
    price: "KSh 5,000 – KSh 20,000",
    duration: "30-90 minutes",
  },
  {
    id: "rehabilitation-counseling",
    title: "Rehabilitation & Counseling",
    shortDesc: "Physical therapy, mental health counseling, and support.",
    fullDesc:
      "Our integrated rehabilitation and counseling services support your physical and mental well‑being. We offer physiotherapy for injury recovery, occupational therapy, and professional counseling to help you navigate life's challenges.",
    icon: FaHeartbeat,
    bgImage: "/assets/services/therapy.png",
    features: [
      "Physiotherapy",
      "Occupational therapy",
      "Individual and group counseling",
      "Stress management",
      "Substance abuse support",
    ],
    benefits: [
      "Holistic care approach",
      "Improved quality of life",
      "Supportive environment",
    ],
    price: "KSh 3,000 – KSh 8,000 per session",
    duration: "45-60 minutes",
  },
  {
    id: "vaccinations",
    title: "Vaccinations",
    shortDesc: "Child and adult immunization programs.",
    fullDesc:
      "We offer a comprehensive vaccination program for children and adults, following national and international guidelines. From routine childhood immunizations to travel vaccines and seasonal flu shots, we ensure you and your family stay protected.",
    icon: FaSyringe,
    bgImage: "/assets/services/vaccine.png",
    features: [
      "Childhood immunizations (WHO schedule)",
      "Travel vaccines",
      "Flu shots",
      "Hepatitis B",
      "HPV vaccine",
    ],
    benefits: [
      "Expert administration",
      "Immunization records",
      "Safe and effective protection",
    ],
    price: "KSh 2,000 – KSh 10,000 per vaccine",
    duration: "15-30 minutes",
  },
  {
    id: "health-checkup-screening",
    title: "General Health Check-up & Screening",
    shortDesc: "Comprehensive health assessments and early detection.",
    fullDesc:
      "Our comprehensive health check‑up packages are designed to detect potential health issues early. We offer customizable screening based on your age, gender, and risk factors. Packages include a full physical examination, laboratory tests, and a detailed report with actionable recommendations.",
    icon: FaChartLine,
    bgImage: "/assets/services/check-up.jpg",
    features: [
      "Comprehensive physical exam",
      "Full blood work",
      "Cardiac assessment",
      "Cancer screening",
      "Lifestyle counseling",
    ],
    benefits: [
      "Early detection of diseases",
      "Peace of mind",
      "Personalized wellness plan",
    ],
    price: "KSh 8,000 – KSh 25,000",
    duration: "2-3 hours",
  },
  {
    id: "home-based-care",
    title: "Home Based Care",
    shortDesc: "Compassionate medical care in the comfort of your home.",
    fullDesc:
      "Our Home Based Care service brings professional healthcare directly to your doorstep. We provide skilled nursing, post-operative care, chronic disease management, and palliative support for patients who prefer or require care at home. Our team works closely with family members to ensure a safe, comfortable, and medically sound environment. Services include wound care, medication management, vital signs monitoring, and patient education. We aim to reduce hospital readmissions and improve quality of life by delivering personalized, compassionate care in familiar surroundings.",
    icon: FaHome,
    bgImage:
      "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=600&auto=format", // professional home care image
    features: [
      "Skilled nursing visits",
      "Post-operative wound care",
      "Medication management and administration",
      "Vital signs monitoring",
      "Chronic disease management (diabetes, hypertension, etc.)",
      "Palliative and end-of-life support",
      "Patient and family education",
      "Coordination with primary physicians",
    ],
    benefits: [
      "Comfort and convenience of home",
      "Reduced risk of hospital-acquired infections",
      "Personalized one-on-one attention",
      "Lower cost compared to inpatient care",
      "Improved adherence to treatment plans",
      "Emotional support for family members",
    ],
    price: "KSh 4,000 – KSh 12,000 per visit",
    duration: "1-2 hours per visit (frequency determined by medical need)",
  },
];
